import React, { Component } from "react";

import {
  Button,
  Checkbox,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControl,
  FormControlLabel,
  FormLabel,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  Switch,
  TextField,
  Typography,
  withStyles,
  RadioGroup,
  Radio
} from "@material-ui/core";

import Edit from "@material-ui/icons/Edit";
import Delete from "@material-ui/icons/Delete";
import AddIcon from "@material-ui/icons/Add";

import MaterialTable from "material-table";
import MaterialTableIcons from "../../../FaqCms/materialTableIcons";

import styles from "../../styles";

import _ from "lodash";
import validate from "validate.js";
import { settingsSchema } from "./schema";

import { connect } from "react-redux";
import { pushMessage } from "../../../../redux/actions/commonActions";
import { updateChatbotCuesSettings } from "../../../../redux/actions/chatbotActions";

const initialValuesState = {
  botName: "",
  welcomeMessage: "",
  examplePhraseA: "",
  voiceEnabled: true,
  bubbles: false,
  continuousListening: false,
  domain: ""
};

class CuesForm extends Component {
  constructor(props) {
    super(props);
    const valid = _.isEmpty(props.data) ? false : true;
    const values = { ...initialValuesState };

    // if we have props.data we put it in our values, otherwise we use our default empty values from initialValuesState
    if (!_.isEmpty(props.data)) {
      // TODO: change all this settings
      values["botName"] = _.get(props.data, "config.botName", "");
      values["welcomeMessage"] = _.get(props.data, "config.welcomeMessage", "");
      values["examplePhraseA"] = _.get(props.data, "config.examplePhrases[0]", "");
      values["voiceEnabled"] = _.get(props.data, "config.voiceEnabled", true);
      values["bubbles"] = _.get(props.data, "config.bubbles", false);
      values["continuousListening"] = _.get(props.data, "config.continuousListening", false);

      values["cues"] = _.get(props.data, "config.cues", []);

      const domainList = _.get(props.data, "allowed_domains", []);
      if (_.isEmpty(domainList)) values["domain"] = "";
      else {
        let domain = "";
        for (let i = 0; i < domainList.length; i++) {
          domain += domainList[i];
          if (i < domainList.length - 1) domain += ", ";
        }
        values["domain"] = domain;
      }
    }

    this.state = {
      open: false,
      isLoading: false,
      values: {
        ...values
      },
      touched: {
        botName: valid,
        welcomeMessage: valid,
        examplePhraseA: valid,
        domain: valid
      },
      errors: {
        botName: null,
        welcomeMessage: null,
        examplePhraseA: null,
        domain: null
      },
      formValid: valid,
      changed: false,
      dialogOpen: false, // cue form dialog
      newOrEdit: "new",
      previousCueName: "",
      currentCue: {
        name: "",
        message: "",
        ruleType: "",
        URL: "",
        sendUtterance: false,
        utteranceMessage: ""
      }
    };
  }

  componentDidMount() {
    this.mounted = true;
    this.validateAllFields();
  }

  componentWillUnmount() {
    this.mounted = false;
  }

  validateAllFields = () => {
    let validationState = { touched: this.state.touched };
    let validationStateErrors = {};
    let fieldValidationNewState;

    for (const field of Object.keys(this.state.values)) {
      fieldValidationNewState = this.validateForm(field, true);
      validationStateErrors = { ...validationStateErrors, ...fieldValidationNewState.errors };
      validationState.touched[field] = fieldValidationNewState.touched[field];
    }

    validationState.errors = validationStateErrors;
    validationState.formValid = !validationStateErrors;

    this.setState(validationState);
  };

  validateForm = (field, returnNewStateObject = false) => {
    const {
      values: { botName, welcomeMessage, examplePhraseA, domain }
    } = this.state;

    const newState = { ...this.state };
    const errors = validate(
      {
        botName,
        welcomeMessage,
        examplePhraseA,
        domain
      },
      settingsSchema
    );

    newState.errors = errors || {};
    newState.touched[field] = true;
    newState.formValid = errors ? false : true;
    newState.changed = true;

    if (returnNewStateObject) {
      return newState;
    }

    this.setState(newState);
  };

  validateFormDebounced = _.debounce(this.validateForm, 200);

  handleInput = (field, value) => {
    const newState = { ...this.state };
    newState.values[field] = value;
    newState.currentCue[field] = value;
    newState.changed = true;
    if (_.includes(["voiceEnabled", "bubbles", "continuousListening"], field)) {
      this.setState(newState);
    } else {
      this.setState(newState, this.validateFormDebounced(field));
    }

    var set = {
      botName: newState.values["botName"],
      welcomeMessage: newState.values["welcomeMessage"],
      // examplePhrases: [newState.values["examplePhraseA"], newState.values["examplePhraseC"]],
      examplePhrases: [newState.values["examplePhraseA"]],
      voiceEnabled: newState.values["voiceEnabled"],
      bubbles: newState.values["bubbles"],
      continuousListening: newState.values["continuousListening"]
    };
    this.props.updateSetting(set);
  };

  // this select is used for chosing upload image method, it is not a typical select
  handleRuleType = value => {
    var newState = { ...this.state };
    newState.currentCue["ruleType"] = value;
    this.setState(newState);
  };

  handleSave = async e => {
    e.preventDefault();
    this.setState({ isLoading: true });
    const {
      values: { botName, welcomeMessage, examplePhraseA, voiceEnabled, bubbles, continuousListening, domain }
    } = this.state;
    // const allowedDomains = domain.replace(/\s/g, "").split(",");

    const cues = this.state.values["cues"];

    await this.props
      .updateChatbotCuesSettings({
        GUID: _.get(this.props, "data.GUID"),
        cues
      })
      .then(() => {
        if (this.mounted) this.setState({ isLoading: false });
      });
  };

  clearAllFormFields = () => {
    this.setState({
      currentCue: {
        name: "",
        message: "",
        ruleType: "",
        URL: "",
        sendUtterance: false,
        utteranceMessage: ""
      }
    });
  };

  handleCreateNewCueClick = () => {
    this.clearAllFormFields();
    this.handleOpenCueDialog("new");
  };

  handleOpenCueDialog = newOrEdit => {
    this.setState({ dialogOpen: true, newOrEdit: newOrEdit });
  };

  handleCloseCueDialog = () => {
    this.setState({ dialogOpen: false });
  };

  handleSaveNewCue = () => {
    let tempValues = this.state.values;
    const previousCues = tempValues.cues;
    const newCue = this.state.currentCue;
    const newListOfCues = [...previousCues, newCue];
    tempValues.cues = newListOfCues;

    this.setState({
      values: tempValues,
      dialogOpen: false
    });

    this.clearAllFormFields();
  };

  handleSaveEditedCue = () => {
    let tempValues = this.state.values;
    const previousCues = tempValues.cues;
    const newCue = this.state.currentCue;

    const editedCueIndex = previousCues.findIndex(x => x.name === newCue.name);

    previousCues[editedCueIndex] = newCue;

    tempValues.cues = previousCues;

    this.setState({
      values: tempValues,
      dialogOpen: false
    });

    this.clearAllFormFields();
  };

  handleDeleteCue = () => {
    let tempValues = this.state.values;
    let previousCues = tempValues.cues;
    const newCue = this.state.currentCue;

    const editedCueIndex = previousCues.findIndex(x => x.name === newCue.name);

    previousCues.splice(editedCueIndex, 1);

    tempValues.cues = previousCues;

    this.setState({
      values: tempValues,
      dialogOpen: false
    });

    this.clearAllFormFields();
  };

  displayRuleTypeInTable = rule => {
    let ruleTypeHTML = "";

    switch (rule) {
      case "default":
        ruleTypeHTML = "Default";
        break;
      case "currentUrlEqual":
        ruleTypeHTML = "Current URL - Equal";
        break;
      case "currentUrlContains":
        ruleTypeHTML = "Current URL - Contains";
        break;
      default:
        ruleTypeHTML = "Rule Type not selected";
    }

    return ruleTypeHTML;
  };

  handleEditCue = (event, rowData) => {
    const allCues = this.state.values.cues;

    const currentCue = allCues.find(cue => cue.name === rowData.name);

    this.setState({
      currentCue: currentCue
    });

    this.handleOpenCueDialog("edit");
  };

  render() {
    const { classes, administrator } = this.props;
    const {
      open,
      isLoading,
      values,
      errors,
      touched,
      formValid,
      changed,
      currentCue, // here is saved the current form
      newOrEdit // is new or editet cue used
    } = this.state;
    const displayBotNameError = touched.botName && errors.botName;
    const displayWelcomeMessageError = touched.welcomeMessage && errors.welcomeMessage;
    const displayExamplePhraseAError = touched.examplePhraseA && errors.examplePhraseA;
    const displayDomainListError = touched.domain && errors.domain;

    // if user sendUtterance checkbox is selected, dont disable utteranceMessage field
    // if user sendUtterance checkbox is not selected, disable utteranceMessage field
    const isUtteranceMessageDisabled = !currentCue.sendUtterance;

    // url field is enabled only if ruleType is "Current URL - Equal" or "Current URL - Contains"
    const isUrlDisabled = currentCue.ruleType === "default" || currentCue.ruleType === "";

    // cues table data format
    this.cuesTableColumns = [
      { title: "Name", field: "name", defaultSort: "asc" },
      { title: "Message", field: "message" },
      { title: "Rule Type", field: "ruleType", render: rowData => this.displayRuleTypeInTable(rowData.ruleType) },
      { title: "URL", field: "URL" },
      {
        title: "Send Utterance",
        field: "sendUtterance",
        //   // render: rowData => formatDate(rowData["dateSubmitted"])
        render: rowData => (rowData.sendUtterance === true ? "Yes" : "No")
      },
      { title: "Utterance Message", field: "utteranceMessage" }
    ];

    return (
      <React.Fragment>
        <div style={{ overflowY: "auto", marginBottom: "20px" }}>
          <MaterialTable
            title="Pop-up messages"
            icons={MaterialTableIcons}
            columns={this.cuesTableColumns}
            data={values["cues"]}
            actions={[
              {
                icon: () => <Edit />,
                tooltip: "Edit Cue",
                onClick: (event, rowData) => this.handleEditCue(event, rowData)
              }
            ]}
            options={{
              sorting: true
            }}
          />
        </div>

        <div>
          <Button
            variant="outlined"
            color="primary"
            onClick={this.handleCreateNewCueClick}
            style={{ marginRight: 20, marginBottom: 12, paddingLeft: 4 }}
          >
            <AddIcon style={{ marginLeft: 5, marginRight: 5 }} />
            Create New Cue
          </Button>
          <Button variant="contained" color="primary" onClick={this.handleSave} style={{ marginBottom: 12 }}>
            Publish Cues
          </Button>

          <Dialog open={this.state.dialogOpen} onClose={this.handleCloseCueDialog} aria-labelledby="form-dialog-title">
            <DialogContent style={{ paddingLeft: "12px", paddingRight: "12px" }}>
              <Grid container spacing={2}>
                <Grid item xs={12} style={{ paddingTop: 12 }}>
                  <Typography variant="h5" component="h5">
                    Cues
                  </Typography>

                  <br />
                  {/*/!*TODO: clear up *!/*/}
                  <TextField
                    id="name"
                    className={classes.textfield}
                    variant="outlined"
                    label="Name"
                    onChange={event => this.handleInput("name", event.target.value)}
                    value={currentCue.name}
                    inputProps={{ maxLength: 100 }}
                    helperText="Cue name. Users don't see cue name, only you can see it."
                  />
                  {displayExamplePhraseAError && (
                    <Typography className={classes.fieldError} variant="body2">
                      {errors.examplePhraseA[0]}
                    </Typography>
                  )}
                </Grid>

                <Grid item xs={12}>
                  <FormControl fullWidth>
                    <TextField
                      id="message"
                      label="Message"
                      multiline
                      rows={4}
                      value={currentCue.message}
                      onChange={event => this.handleInput("message", event.target.value)}
                      variant="outlined"
                      helperText="Message that will be displayed inside pop-up"
                    />
                  </FormControl>
                </Grid>

                <Grid item xs={12}>
                  <TextField
                    className={classes.formControl}
                    id="ruleType"
                    select
                    label="Rule Type"
                    value={currentCue.ruleType}
                    onChange={event => this.handleRuleType(event.target.value)}
                    variant="outlined"
                    helperText="Select on which URL you want to display this Cue setting"
                  >
                    <MenuItem id="default" value="default">
                      All URLs - Default
                    </MenuItem>
                    <MenuItem id="currentUrlEqual" value="currentUrlEqual">
                      Current URL - Equal
                    </MenuItem>
                    <MenuItem id="currentUrlContains" value="currentUrlContains">
                      Current URL - Contains
                    </MenuItem>
                  </TextField>
                </Grid>

                <Grid item xs={12}>
                  <TextField
                    id="URL"
                    className={classes.textfield}
                    variant="outlined"
                    label="URL"
                    onChange={event => this.handleInput("URL", event.target.value)}
                    value={currentCue.URL}
                    inputProps={{ maxLength: 100 }}
                    helperText="Enter URL for 'Current URL - Equal' or 'Current URL - Containes'. Default option doesn't need URL since it is displayed on all pages"
                    disabled={isUrlDisabled}
                  />
                  {displayExamplePhraseAError && (
                    <Typography className={classes.fieldError} variant="body2">
                      {errors.examplePhraseA[0]}
                    </Typography>
                  )}
                </Grid>

                <Grid item xs={4} className={classes.sliderText}>
                  <Typography variant="body1">Send utterance</Typography>
                </Grid>
                <Grid item xs={8}>
                  <div className={classes.actionsIcon}>
                    <span>
                      <Switch
                        checked={currentCue.sendUtterance}
                        onClick={() => this.handleInput("sendUtterance", !values.sendUtterance)}
                      />
                    </span>
                  </div>
                </Grid>

                <Grid item xs={12}>
                  <FormControl fullWidth>
                    <TextField
                      id="utteranceMessage"
                      label="Utterance Message"
                      multiline
                      rows={4}
                      value={currentCue.utteranceMessage}
                      onChange={event => this.handleInput("utteranceMessage", event.target.value)}
                      variant="outlined"
                      helperText="If 'Send Utterance' option is selected, this message will be sent by clicking on the pop-up"
                      disabled={isUtteranceMessageDisabled}
                    />
                  </FormControl>
                </Grid>
              </Grid>
            </DialogContent>
            <DialogActions>
              <Button onClick={this.handleCloseCueDialog} color="primary">
                Cancel
              </Button>
              {newOrEdit === "edit" ? (
                <div>
                  <Button
                    onClick={this.handleDeleteCue}
                    color="secondary"
                    variant="contained"
                    style={{ marginRight: 12 }}
                  >
                    <Delete style={{ marginRight: 6 }} />
                    Delete Cue
                  </Button>
                  <Button onClick={this.handleSaveEditedCue} color="primary" variant="contained">
                    Save Cue
                  </Button>
                </div>
              ) : (
                <Button onClick={this.handleSaveNewCue} color="primary" variant="contained">
                  Create New Cue
                </Button>
              )}
            </DialogActions>
          </Dialog>
        </div>

        <br />
        {/*<Paper className={classes.row} elevation={0}>*/}
        {/*  <form onSubmit={this.handleSave}>*/}
        {/*    <Grid container spacing={2}>*/}
        {/*      <Grid item xs={12} md={6}>*/}
        {/*        <TextField*/}
        {/*          id="bot_name"*/}
        {/*          className={classes.textfield}*/}
        {/*          variant="outlined"*/}
        {/*          label="Bot Name"*/}
        {/*          onChange={event => this.handleInput("botName", event.target.value)}*/}
        {/*          value={values.botName}*/}
        {/*          inputProps={{ maxLength: 30 }}*/}
        {/*        />*/}
        {/*        {displayBotNameError && (*/}
        {/*          <Typography className={classes.fieldError} variant="body2">*/}
        {/*            {errors.botName[0]}*/}
        {/*          </Typography>*/}
        {/*        )}*/}
        {/*      </Grid>*/}
        {/*      <Grid item xs={12}>*/}
        {/*        <TextField*/}
        {/*          id="welcome_message"*/}
        {/*          className={classes.textfield}*/}
        {/*          variant="outlined"*/}
        {/*          label="Welcome Message"*/}
        {/*          onChange={event => this.handleInput("welcomeMessage", event.target.value)}*/}
        {/*          value={values.welcomeMessage}*/}
        {/*          multiline*/}
        {/*          rowsMax={7}*/}
        {/*          inputProps={{ maxLength: 500 }}*/}
        {/*        />*/}
        {/*        {displayWelcomeMessageError && (*/}
        {/*          <Typography className={classes.fieldError} variant="body2">*/}
        {/*            {errors.welcomeMessage[0]}*/}
        {/*          </Typography>*/}
        {/*        )}*/}
        {/*      </Grid>*/}
        {/*      <Grid item xs={4} className={classes.sliderText}>*/}
        {/*        <Typography variant="body1">Bubbles:</Typography>*/}
        {/*      </Grid>*/}
        {/*      <Grid item xs={8}>*/}
        {/*        <div className={classes.actionsIcon}>*/}
        {/*          <span>*/}
        {/*            <Switch checked={values.bubbles} onClick={() => this.handleInput("bubbles", !values.bubbles)} />*/}
        {/*          </span>*/}
        {/*        </div>*/}
        {/*      </Grid>*/}

        {/*      <Grid item xs={12}>*/}
        {/*        {isLoading ? (*/}
        {/*          <CircularProgress className={classes.progress} />*/}
        {/*        ) : (*/}
        {/*          <Button*/}
        {/*            className={classes.saveButton}*/}
        {/*            color="primary"*/}
        {/*            disabled={!formValid || !changed}*/}
        {/*            size="large"*/}
        {/*            variant="contained"*/}
        {/*            type="submit"*/}
        {/*          >*/}
        {/*            Save Settings*/}
        {/*          </Button>*/}
        {/*        )}*/}
        {/*      </Grid>*/}
        {/*    </Grid>*/}
        {/*  </form>*/}
        {/*</Paper>*/}
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => ({
  administrator: _.get(state.auth.cognitoUser.attributes, "custom:role", "user") === "Administrator"
});

CuesForm = connect(
  mapStateToProps,
  { pushMessage, updateChatbotCuesSettings }
)(CuesForm);

export default withStyles(styles)(CuesForm);
